import Vue from 'vue';
import { store } from '@/store'
import { mapState } from 'vuex';
import router from '@/router'

import { ApiService } from '@/services/api.service'
import { Log } from '@/services/log.service'

import { KombiRepository } from '@/repositories/KombiRepository';
import { KomponentenRepository } from '@/repositories/KomponentenRepository';


export const Finder = new Vue({
	store,
	router,
	computed: {
		...mapState(['settings', 'globals']),
		...mapState('configurator', ['configurator', 'kombis', 'komponenten']),
	},

	methods: {

		/**
		 * 	Valide Kombination für ein Produkt finden
		 * 	
		 * 	Ich bin im Bereich 'nasal'. Finde alle Flaschen-Varianten für mich:
		 *	Finder.findByCriteria({bereich:'nasal'}, 'flasche');
		 */
		findByCriteria( criteria, optionName ) {

			// Klon, um überschreiben zu vermeiden
			var clonedCriteria = Object.assign({}, criteria);

			// Wir wollen ALLE Varianten für angegebene Option (z.B. "verschluss") sehen
			if (optionName) {
				delete( clonedCriteria[optionName] );
			}

			// [<VarianteQueryResult>, ...]
			var varianteQueryResults = KombiRepository.findVariants( clonedCriteria, optionName );

			// aktuelle Filterungen markieren
			var mergedCriteria = Object.assign({}, KombiRepository.getGlobalCriteria(), criteria);
			//console.log('Filter: ', mergedCriteria);

			if (Object.keys(criteria).length) {
				varianteQueryResults.forEach((item) => {
					item.selected = item.result.matches( mergedCriteria ) && criteria[optionName];
				});
			}
			
			return varianteQueryResults;
		}

	}
});



// WEBPACK FOOTER //
// ./src/services/finder.service.js